/** Nivo theme matching the CRM design system (shared by every chart page). */
export const nivoTheme = {
  text: {
    fontSize: 12,
    fontFamily: "'Lato', 'Inter', sans-serif",
    fill: '#8181a5',
  },
  axis: {
    ticks: {
      text: { fontSize: 11, fill: '#8181a5' },
      line: { stroke: '#ececf2' },
    },
    legend: {
      text: { fontSize: 12, fontWeight: 600, fill: '#1c1d21' },
    },
  },
  grid: {
    line: { stroke: '#f0f0f3', strokeWidth: 1 },
  },
  crosshair: {
    line: { stroke: '#5e81f4', strokeWidth: 1, strokeDasharray: '4 4' },
  },
  tooltip: {
    container: {
      background: '#fff',
      borderRadius: 8,
      boxShadow: '0 4px 16px rgba(0,0,0,.1)',
      padding: '8px 12px',
      fontSize: 13,
      fontFamily: "'Lato', 'Inter', sans-serif",
    },
  },
};
